@for (item of filteredViews(); track item) {
  <app-view-item
    [view]="item"
    [active]="active()"
    (onUpdate)="toggleAddViewDialog(false)"
    (onSelect)="select(item)"
    (onDelete)="delete(item.name)"
  ></app-view-item>
}
